module.exports = __webpack_public_path__ + "img/trench.688c86b0.png";